module.exports = "<p>\n  payment-chall-app-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/payment-chall-approval/payment-chall-app-form/payment-chall-app-form.component.html
// module id = ./src/app/recovery/payment-chall-approval/payment-chall-app-form/payment-chall-app-form.component.html
// module chunks = main